<mat-form-field [floatLabel]="formArray.length > 0 ? 'always' : 'auto'">
  <mat-label>{{ label }}</mat-label>
  @if (formArray.length > 0) {
    <div>
      <mat-chip-set>
        @for (control of formArray.controls.slice(0, 3); track control; let index = $index) {
          <mat-chip
            [removable]="true"
            color="accent"
            (removed)="removeChip(index, control.value)">
            {{ control.value.displayName }}
            <mat-icon matChipRemove
              class="mat-chip-remove-icon"
              (click)="$event.stopPropagation()">
              cancel
            </mat-icon>
          </mat-chip>
        }
        @if (formArray.length > 3) {
          <mat-chip
            (click)="$event.stopPropagation(); $event.preventDefault()"
            color="accent"
            #menuTrigger="matMenuTrigger"
            [matMenuTriggerFor]="menu"
            class="more-chip">
            <span>+{{ formArray.length - 3 }} more</span>
            <mat-icon matChipTrailingIcon
              class="menu-icon">
              more_vert
            </mat-icon>
          </mat-chip>
        }
      </mat-chip-set>
      <mat-menu #menu="matMenu">
        @for (control of formArray.controls.slice(3); track control; let index = $index) {
          <div
            mat-menu-item>
            <mat-checkbox color="primary"
              [checked]="true"
              (click)="$event.stopPropagation(); $event.preventDefault()"
              (change)="onRemoveFromMenu(control.value)">
            </mat-checkbox>
            {{ control.value.displayName }}
          </div>
        }
      </mat-menu>
    </div>
  }
  <mat-select #select="matSelect"
    (selectionChange)="onSelectionChange($event)"
    [formControl]="selectControl">
    <mat-option class="search-option autocomplete-select-option">
      <div class="mat-select-search-inner-row">
        <input class="mat-select-search-input"
          [formControl]="formControl"
          [placeholder]="placeholder"
          (keydown.space)="$event.stopPropagation()"
          (click)="$event.stopPropagation()"
          matInput
          />

        @if (searching) {
          <mat-spinner
            class="mat-select-search-spinner"
          diameter="16"></mat-spinner>
        }

        @if (formControl.value && !searching) {
          <button
            mat-icon-button
            aria-label="Clear"
            (click)="clearSearch($event)"
            class="mat-select-search-clear">
            <mat-icon>
              close
            </mat-icon>
          </button>
        }
      </div>

    </mat-option>
    <mat-divider></mat-divider>
    @if (formControl.value) {
      @for (option of displayedOptions; track option.id) {
        <mat-option
          [value]="option"
          class="autocomplete-select-option">
          <div (click)="optionClicked($event, option)">
            <mat-checkbox color="primary"
              [checked]="isChecked(option)"
              (change)="toggleSelection(option)"
              (click)="$event.stopPropagation()">
            </mat-checkbox>
            {{ option.displayName }}
          </div>
        </mat-option>
      }
      @if (hasMoreItems) {
        <mat-option
          [disabled]="true"
          class="more-items-option">
          <div class="more-items-text">
            {{ getRemainingItemsCount() }} more items available. Type to continue filtering.
          </div>
        </mat-option>
      }
    }
    @if (!formControl.value) {
      <mat-optgroup label="{{formArray.length}} Selected"
        class="selected-items">
        @if (formArray.length > 0) {
          <button
            (click)="clearSelections($event)"
            mat-button
            color="accent"
            class="clear-selections-button">
            Clear all
          </button>
        }
        @for (control of formArray.controls; track control) {
          <mat-option
            [value]="control.value"
            class="autocomplete-select-option">
            <div (click)="optionClicked($event, control.value)"
              class="autocomplete-select-option-inner">
              <mat-checkbox color="primary"
                [checked]="true">
              </mat-checkbox>
              {{ control.value.displayName }}
            </div>
          </mat-option>
        }
      </mat-optgroup>
      <mat-optgroup label="Available">
        @for (option of displayedOptions; track option.id) {
          <mat-option
            [value]="option"
            class="autocomplete-select-option">
            <div (click)="optionClicked($event, option)"
              class="autocomplete-select-option-inner">
              <mat-checkbox color="primary"
                [checked]="isChecked(option)">
              </mat-checkbox>
              {{ option.displayName }}
            </div>
          </mat-option>
        }
        @if (hasMoreItems) {
          <mat-option
            [disabled]="true"
            class="more-items-option">
            <div class="more-items-text">
              {{ getRemainingItemsCount() }} more items available. Type to search.
            </div>
          </mat-option>
        }
      </mat-optgroup>
    }

    @if (filteredOptions.length === 0 && !searching) {
      <div class="no-results">
        No results found.
      </div>
    }
  </mat-select>
</mat-form-field>
